import __var_0__ from './cabs2.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the squared absolute value of a complex number.
*
* @module @stdlib/math/base/complex/abs2
*
* @example
* var cabs2 = require( '@stdlib/math/base/complex/abs2' );
*
* var v = cabs2( 5.0, 3.0 );
* // returns 34.0
*/

// MODULES //
var cabs2 = __var_0__;


// EXPORTS //
export default cabs2;
